export class ContentControlledEditingDirectiveInstructions {
  constructor(
    public density?: number,
    public sampleDistance?: number,
    public beepFrequency?: number,
    public scaleFactor?: number,
  ) {}
  static getBlurInstructions(): ContentControlledEditingDirectiveInstructions {
    return new ContentControlledEditingDirectiveInstructions(
      undefined,
      5,
      undefined,
      undefined,
    );
  }
  static getPixelateInstructions(): ContentControlledEditingDirectiveInstructions {
    return new ContentControlledEditingDirectiveInstructions(
      35,
      undefined,
      undefined,
      undefined,
    );
  }
  static getBeepFrequencyInstructions(): ContentControlledEditingDirectiveInstructions {
    return new ContentControlledEditingDirectiveInstructions(
      undefined,
      undefined,
      440,
      undefined,
    );
  }
}
